module.exports = __webpack_public_path__ + "icon_mail.svg?dcfce8d71b11f3e638bc008c1d3ac75d";


//////////////////
// WEBPACK FOOTER
// ./src/img/navbar/icon_mail.svg
// module id = 86
// module chunks = 0